import {createSelector} from 'reselect';
import {isMobile} from './DeviceSelectors';
import {getSettings} from './selectors';

export const getExperiment = state => state.start.siteDataV2.clientExperiments;

const payPalVariants = ['v1|paypal_express_side_by_side', 'v2|paypal_express_drop_down', 'v3|paypal_express_text'];

export const getIsRedesignPhase1BExperimentCTAVariant = createSelector(
  [getExperiment],
  experiment => experiment?.redesign_phase1b_wave_02 === 'v2|redesign_phase1b_with_ctas',
);

export const isCollapsibleExperiment = createSelector(
  [getExperiment, isMobile],
  (experiment, mobile) => experiment?.collapsible_sections_wave_01 === 'v1|collapsible_sections'
    || (payPalVariants.includes(experiment?.paypal_express_wave_02) && !mobile),
);

export const isInPaypalExperiment = createSelector(
  [getExperiment],
  experiment => payPalVariants.includes(experiment?.paypal_express_wave_02),
);

export const isLoqateSortingExperiment = createSelector(
  [getExperiment, getSettings],
  (experiment, settings) => experiment?.loqate_address_sorting_wave_1 === 'v1|loqate_address_sorting'
    || settings?.should_do_sort_loqate,
);

export const isRedirectToLoginExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.show_return_to_login_wave_01 === 'v1|show_return_to_login',
);

export const isLoyaltyExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.show_loyalty_points_wave_01 === 'v1|show_loyalty_points',
);

export const inEditDeleteExperiment = createSelector(
  [getExperiment, getSettings],
  (experiment, settings) => experiment?.show_edit_delete_option_wave_01 === 'v1|show_edit_delete_option'
    || settings?.show_edit_delete_option,
);

export const getIsInCardChunkingExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.card_number_chunking_wave_01 === 'v1|card_number_chunking',
);

export const isCardExpiryDateExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.show_card_expiry_text_input_field_01 === 'v1|show_card_expiry_text_input_field',
);

export const getIsCardExpiryDateWave2Experiment = createSelector(
  [getExperiment],
  experiment => experiment?.show_card_expiry_text_input_field_02 === 'v2|show_card_expiry_text_input_field',
);

export const getIsInCombinedUXExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.enable_combined_ux_experiments_wave_01 === 'v1|enable_combined_ux_experiments',
);

export const getShouldShowReturnToBasketCTAExperiment = createSelector(
  [getExperiment],
  experiment => experiment?.show_return_to_basket_cta_01 === 'v1|show_return_to_basket_cta_01',
);

export const getIsInJapanLoqateExperiment = createSelector(
  [getExperiment, getSettings],
  (experiment, settings) => experiment?.show_loqate_input_for_japan_01 === 'v1|show_loqate_input_for_japan_01'
    || !!settings?.activate_loqate_v4,
);
